import { DROP_D_TUNING, STANDARD_TUNING, type Tuning } from './fretboard';

export const TUNINGS: readonly Tuning[] = [STANDARD_TUNING, DROP_D_TUNING];

                                               
                                                             
 
